export { ArticleMiniGroup } from './ArticleMiniGroup';
export type { ArticleMiniGroupProps } from './ArticleMiniGroup';
